import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
    CircularProgress,
    Alert,
    Grid,
    Card,
    CardContent,
} from "@mui/material";
import { getDashboard } from "../../Apis/DashboardApi";

const DashboardPage = () => {
    const [dashboardData, setDashboardData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const fetchDashboard = async () => {
        try {
            setLoading(true);
            const data = await getDashboard();
            setDashboardData(data.data); // adjust based on response structure
            setError("");
        } catch (err) {
            console.error(err);
            setError("Failed to fetch dashboard data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchDashboard();
    }, []);

    if (loading) {
        return (
            <Box sx={{ textAlign: "center", mt: 5 }}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box sx={{ textAlign: "center", mt: 5 }}>
                <Alert severity="error">{error}</Alert>
            </Box>
        );
    }

    return (
        <Box sx={{ p: 3 }} >
            <Typography variant="h4" gutterBottom>
                Dashboard
            </Typography>
            <Grid container spacing={3}>
                {[
                    {
                        title: "Total Users",
                        content: dashboardData.totalUsers,
                    },
                    {
                        title: "Total Revenue",
                        content: `₹${dashboardData.totalRevenue}`,
                    },
                    {
                        title: "Categories",
                        content: (
                            <>
                                <Typography variant="body2">Active: {dashboardData.categories.active}</Typography>
                                <Typography variant="body2">Inactive: {dashboardData.categories.inactive}</Typography>
                            </>
                        ),
                    },
                    {
                        title: "Products",
                        content: (
                            <>
                                <Typography variant="body2">Active: {dashboardData.products.active}</Typography>
                                <Typography variant="body2">Inactive: {dashboardData.products.inactive}</Typography>
                            </>
                        ),
                    },
                    {
                        title: "Bookings",
                        content: (
                            <>
                                <Typography variant="body2">Paid: {dashboardData.bookings.paid}</Typography>
                                <Typography variant="body2">Unpaid: {dashboardData.bookings.unpaid}</Typography>
                            </>
                        ),
                    },
                ].map((item, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index} width={"40%"}>
                        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                            <CardContent sx={{ flexGrow: 1 }}>
                                <Typography variant="h6" gutterBottom>
                                    {item.title}
                                </Typography>
                                <Typography variant="h4">
                                    {typeof item.content === "string" || typeof item.content === "number"
                                        ? item.content
                                        : ""}
                                </Typography>
                                {typeof item.content !== "string" && typeof item.content !== "number" && item.content}
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default DashboardPage;
